import * as React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Paper, InputBase, IconButton, Grid } from "@mui/material";

export default function Search({ setSearchBrands, setPage, setBrands }) {
  function handleSearch(e) {
    setPage(1);

    setSearchBrands(e.target.value);
  }

  return (
    <Grid item paddingRight="43px">
      <Paper
        component="form"
        elevation={0}
        sx={{
          p: "15px 18px",
          display: "flex",
          alignItems: "center",
          width: "20vw",
          height: "50px",
          borderRadius: "30px",
          justifyContent: "space-between",
          boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
        }}
      >
        <InputBase
          sx={{
            ml: 1,
            flex: 1,
            color: "rgba(128, 128, 128, 0.7)",
          }}
          placeholder="Search "
          onChange={handleSearch}
        />

        <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
          <SearchIcon style={{ color: "#231F20" }} />
        </IconButton>
      </Paper>
    </Grid>
  );
}
